import {createAction, props} from '@ngrx/store';
import {CommerceErrorInterface} from '../error-handling/commerce-error';
import {ContextData} from './context-data';

export const loadContextData = createAction(
  '[ContextData] Load Context Data',
  props<{contextJson: string}>(),
);

export const loadContextDataSuccess = createAction(
  '[ContextData] Load Context Data Success',
  props<{context: ContextData}>(),
);

export const loadContextDataFailure = createAction(
  '[ContextData] Load Context Data Failure',
  props<{error: CommerceErrorInterface}>(),
);

export const resetState = createAction('[ContextData] reset ngrx state');

export const updateContextData = createAction(
  '[ContextData] Update Context Data',
  props<{
    context: Partial<ContextData>;
  }>(),
);
